// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var MapAttribute$ReactHooksTemplate = require("./mapAttribute.res.js");
var TableAttribute$ReactHooksTemplate = require("./tableAttribute.res.js");
var GenericChartAttribute$ReactHooksTemplate = require("./genericChartAttribute.res.js");
var ScoreCardChartAttribute$ReactHooksTemplate = require("./scoreCardChartAttribute.res.js");

function id(t) {
  return t.id;
}

function title(t) {
  return t.title;
}

function type_(t) {
  return t.type_;
}

function setType(t, type_) {
  return {
          id: t.id,
          type_: type_,
          title: t.title
        };
}

function setTitle(t, title) {
  return {
          id: t.id,
          type_: t.type_,
          title: title
        };
}

function chartTypeToString(t) {
  var match = t.type_;
  if (typeof match !== "object") {
    return "Empty Chart";
  }
  switch (match.TAG) {
    case "LineChart" :
        return "Line Graph";
    case "AreaChart" :
        return "Area Chart";
    case "PieChart" :
        return "Pie Chart";
    case "BarChart" :
        return "Bar Graph";
    case "RadialBarChart" :
        return "Radial Chart";
    case "Wordcloud" :
        return "Word Cloud";
    case "ComposedChart" :
        return "Composed Chart";
    case "ScoreCard" :
        return "Score Card";
    case "Map" :
        return "Map";
    case "Table" :
        return "Table";
    
  }
}

function compatibleCharts(t) {
  var match = t.type_;
  if (typeof match !== "object") {
    return {
            hd: "Empty Chart",
            tl: /* [] */0
          };
  }
  switch (match.TAG) {
    case "RadialBarChart" :
        return {
                hd: "Radial Graph",
                tl: /* [] */0
              };
    case "Wordcloud" :
        return {
                hd: "Word Cloud",
                tl: /* [] */0
              };
    case "ComposedChart" :
        return {
                hd: "Composed Chart",
                tl: /* [] */0
              };
    case "ScoreCard" :
        return {
                hd: "Score Card",
                tl: /* [] */0
              };
    case "Map" :
        return {
                hd: "Map",
                tl: /* [] */0
              };
    case "Table" :
        return {
                hd: "Table",
                tl: /* [] */0
              };
    default:
      return {
              hd: "Bar Graph",
              tl: {
                hd: "Line Graph",
                tl: {
                  hd: "Pie Chart",
                  tl: {
                    hd: "Area Chart",
                    tl: /* [] */0
                  }
                }
              }
            };
  }
}

function toJson(t) {
  var match = t.type_;
  var chartType;
  if (typeof match !== "object") {
    chartType = "empty";
  } else {
    switch (match.TAG) {
      case "LineChart" :
          chartType = "line";
          break;
      case "AreaChart" :
          chartType = "area";
          break;
      case "PieChart" :
          chartType = "pie";
          break;
      case "BarChart" :
          chartType = "bar";
          break;
      case "RadialBarChart" :
          chartType = "radial";
          break;
      case "Wordcloud" :
          chartType = "word_cloud";
          break;
      case "ComposedChart" :
          chartType = "composed";
          break;
      case "ScoreCard" :
          chartType = "score_card";
          break;
      case "Map" :
          chartType = "map";
          break;
      case "Table" :
          chartType = "table";
          break;
      
    }
  }
  return Json_encode.object_({
              hd: [
                "chart_name",
                t.title
              ],
              tl: {
                hd: [
                  "chart_type",
                  chartType
                ],
                tl: /* [] */0
              }
            });
}

function decodeItem(json) {
  var category = Json_decode.either((function (param) {
            return Json_decode.field("chart_type", Json_decode.string, param);
          }), (function (param) {
            return Json_decode.field("visualization_type", Json_decode.string, param);
          }))(json);
  return {
          id: Json_decode.field("id", Json_decode.$$int, json),
          type_: category === "radial_bar" ? ({
                TAG: "RadialBarChart",
                _0: GenericChartAttribute$ReactHooksTemplate.fromJson(json)
              }) : (
              category === "map" ? ({
                    TAG: "Map",
                    _0: MapAttribute$ReactHooksTemplate.fromJson(json)
                  }) : (
                  category === "table" ? ({
                        TAG: "Table",
                        _0: TableAttribute$ReactHooksTemplate.fromJson(json)
                      }) : (
                      category === "line" ? ({
                            TAG: "LineChart",
                            _0: GenericChartAttribute$ReactHooksTemplate.fromJson(json)
                          }) : (
                          category === "pie" ? ({
                                TAG: "PieChart",
                                _0: GenericChartAttribute$ReactHooksTemplate.fromJson(json)
                              }) : (
                              category === "area" ? ({
                                    TAG: "AreaChart",
                                    _0: GenericChartAttribute$ReactHooksTemplate.fromJson(json)
                                  }) : (
                                  category === "bar" ? ({
                                        TAG: "BarChart",
                                        _0: GenericChartAttribute$ReactHooksTemplate.fromJson(json)
                                      }) : (
                                      category === "wordcloud" ? ({
                                            TAG: "Wordcloud",
                                            _0: GenericChartAttribute$ReactHooksTemplate.fromJson(json)
                                          }) : (
                                          category === "score_card" ? ({
                                                TAG: "ScoreCard",
                                                _0: ScoreCardChartAttribute$ReactHooksTemplate.fromJson(json)
                                              }) : (
                                              category === "composed" ? ({
                                                    TAG: "ComposedChart",
                                                    _0: GenericChartAttribute$ReactHooksTemplate.fromJson(json)
                                                  }) : "EmptyChart"
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            ),
          title: Json_decode.field("title", Json_decode.string, json)
        };
}

function fromJson(json) {
  return Json_decode.field("visualization", decodeItem, json);
}

exports.fromJson = fromJson;
exports.title = title;
exports.type_ = type_;
exports.id = id;
exports.setType = setType;
exports.chartTypeToString = chartTypeToString;
exports.setTitle = setTitle;
exports.compatibleCharts = compatibleCharts;
exports.toJson = toJson;
/* GenericChartAttribute-ReactHooksTemplate Not a pure module */
